import { supabase, normalizeError } from '@/lib/supabaseClient'

export async function fetchProjectImages(projectId) {
  try {
    const { data, error } = await supabase
      .from('project_images')
      .select('*')
      .eq('project_id', projectId)
      .order('display_order', { ascending: true })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function createProjectImage(imageData) {
  try {
    const { data, error } = await supabase
      .from('project_images')
      .insert(imageData)
      .select()
      .single()

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function updateProjectImage(imageId, updates) {
  try {
    const { data, error } = await supabase
      .from('project_images')
      .update(updates)
      .eq('id', imageId)
      .select()
      .single()

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function deleteProjectImage(imageId) {
  try {
    const { error } = await supabase
      .from('project_images')
      .delete()
      .eq('id', imageId)

    if (error) throw error
    return { error: null }
  } catch (error) {
    return { error: normalizeError(error) }
  }
}

export async function reorderProjectImages(projectId, imageIds) {
  try {
    const updates = imageIds.map((imageId, index) =>
      supabase
        .from('project_images')
        .update({ display_order: index })
        .eq('id', imageId)
        .eq('project_id', projectId)
    )

    await Promise.all(updates)
    return { error: null }
  } catch (error) {
    return { error: normalizeError(error) }
  }
}
